export const emailValidatorPattern = '^[\\s]*(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))[\\s]*$'

export const commaDelimitedEmailValidatorPattern = '^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$'

export const postalCodeValidatorPattern = '^[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ -]?\\d[ABCEGHJ-NPRSTV-Z]\\d$'

export const zipCodeValidatorPattern = '^[0-9]{5}(?:-[0-9]{4})?$'

export const phoneValidatorPattern = '^[0-9]{10,11}$'
 
export const learnerIdValidatorPattern = "^[a-zA-Z0-9]*$"

export const programIdValidatorPattern = '^[0-9]{5,6}$'

export const birthYearValidatorPattern = '^[0-9]{4}$'

export const websiteValidatorPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'


